import { supabase } from "@/integrations/supabase/client";

const clientToken = import.meta.env.VITE_PAYMENTS_CLIENT_TOKEN;

declare global {
  interface Window { Paddle: any; }
}

export function getPaddleEnvironment(): "sandbox" | "live" {
  return clientToken?.startsWith("test_") ? "sandbox" : "live";
}

let paddleInitialized = false;
export async function initializePaddle() {
  if (paddleInitialized) return;
  if (!clientToken) throw new Error("VITE_PAYMENTS_CLIENT_TOKEN is not set");
  return new Promise<void>((resolve, reject) => {
    const script = document.createElement("script");
    script.src = "https://cdn.paddle.com/paddle/v2/paddle.js";
    script.onload = () => {
      const paddleJsEnv = getPaddleEnvironment() === "sandbox" ? "sandbox" : "production";
      window.Paddle.Environment.set(paddleJsEnv);
      window.Paddle.Initialize({ token: clientToken });
      paddleInitialized = true;
      resolve();
    };
    script.onerror = reject;
    document.head.appendChild(script);
  });
}

export async function getPaddlePriceId(priceId: string): Promise<string> {
  const environment = getPaddleEnvironment();
  const { data, error } = await supabase.functions.invoke("get-paddle-price", {
    body: { priceId, environment },
  });
  if (error || !data?.paddleId) throw new Error(`Failed to resolve price: ${priceId}`);
  return data.paddleId;
}

// Tier hierarchy for feature gating
export const TIER_RANK: Record<string, number> = {
  starter_plan: 1,
  pro_plan: 2,
  enterprise_plan: 3,
};

export const TIER_LIMITS: Record<string, { projects: number; contacts: number; aiMessages: number; seats: number }> = {
  starter_plan: { projects: 10, contacts: 100, aiMessages: 200, seats: 1 },
  pro_plan: { projects: 100, contacts: 2000, aiMessages: 2000, seats: 5 },
  enterprise_plan: { projects: Infinity, contacts: Infinity, aiMessages: Infinity, seats: Infinity },
};
